import { createReducer } from "@utils/storeUtils";
import { AvailableFilters, SortingKeys } from "@utils/enums";
import subDays from "date-fns/sub_days";
import startOfDay from "date-fns/start_of_day";
import endOfDay from "date-fns/end_of_day";
const daysToFetch = 2;
export const initialState = {
    jobs: [],
    jobInputFiles: [],
    jobOutputFiles: [],
    totalItems: 0,
    pageNumber: 0,
    pageSize: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    nextPageNumber: 0,
    previousPageNumber: 0,
    isLoading: true,
    filters: {
        [AvailableFilters.CREATED_FROM]: startOfDay(subDays(Date.now(), daysToFetch)),
        [AvailableFilters.CREATED_TO]: endOfDay(Date.now())
    },
    ordering: {
        OrderBy: SortingKeys.CREATED,
        Ascending: false
    }
};
const fetchPdfJobs = (state, action) => {
    const { payload: { elements, ...meta } } = action;
    return {
        ...state,
        jobs: elements,
        isLoading: false,
        ...meta
    };
};
const setFilters = (state, action) => ({
    ...state,
    filters: {
        ...action.payload
    }
});
const setOrdering = (state, action) => ({
    ...state,
    ordering: {
        ...action.payload
    }
});
const setLoadingStatus = (state, action) => ({
    ...state,
    isLoading: action.type === "FETCH_PDF_JOBS"
});
const actionReducerMap = {
    ["FETCH_PDF_JOBS_SUCCESS"]: fetchPdfJobs,
    ["FETCH_PDF_JOBS_FAIL"]: setLoadingStatus,
    ["FETCH_PDF_JOBS"]: setLoadingStatus,
    ["SET_FILTERS"]: setFilters,
    ["SET_ORDERING"]: setOrdering
};
export default createReducer(initialState, actionReducerMap);
